import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ErrorBoundary from './errorBoundary';
import 'bootstrap/dist/css/bootstrap.css';
import 'underscore/underscore-min';
import './Custom.css';
import { registerLicense } from '@syncfusion/ej2-base';

registerLicense('Ngo9BigBOggjHTQxAR8/V1JGaF5cX2JCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWH1dcXVdQ2lfU0F/X0RWYEs=');

ReactDOM.render(<ErrorBoundary><App /></ErrorBoundary>, document.getElementById('rootElement'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();